export default __webpack_public_path__ + "static/media/2.fire-extinguisher.88e49e32.jpg";